import cx from 'classnames';

import { GlossIcon } from 'glossDS/Icons/GlossIcon/GlossIcon';

import { useCart } from 'hooks/cart/useCart';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import styles from './BagCounter.module.css';

type Props = {
  className?: string;
  size?: number;
};

export const BagCounter = ({ size = 24, className }: Props) => {
  const { getTotalItemCount } = useCart();
  const { theme } = useGGTheme();

  const customColor = theme?.palette?.bgPrimary;
  const counterColor =
    customColor &&
    (typeof customColor === 'string' || customColor instanceof String)
      ? (customColor as string)
      : 'inherit';

  const itemsCount = getTotalItemCount();
  const hasItems = itemsCount > 0;

  return (
    <div className={cx(styles.wrapper, className)}>
      <GlossIcon
        className={styles.icon}
        icon="shopping-bag-4-line"
        size={size}
      />
      {hasItems && (
        <span
          className={styles.counter}
          style={{
            color: counterColor,
          }}
        >
          {getTotalItemCount()}
        </span>
      )}
    </div>
  );
};
